import React, { createContext, useState, useEffect } from 'react';
import { Modal } from 'antd';
import useStore from '../hooks/useStore';

export const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const initUser = localStorage.getItem('evidenceB-user') ?
    JSON.parse(localStorage.getItem('evidenceB-user')) : null;
  const [user, storeUser] = useStore(initUser, 'user');


  const [content, setContent] = useStore({}, 'content', !!user && user.token);
  const [sequence, storeSequence] = useStore({}, 'sequence', !!user && user.token);
  const [answers, storeAnswers] = useStore({}, 'trackAnswers', !!user && user.token);

  // to-do no need to store that
  const [path, storePath] = useStore({}, 'trackPath', !!user && user.token);
  const [activityId, storeActivityId] = useStore({},'trackActivity', !!user && user.token);
  const [action, storeAction] = useStore({}, 'action', !!user && user.token);


  useEffect(() => {
    console.log('Store is mounted');
    return () => console.log('Store is unmounted');
  }, []);

  const errorObj = {
    title: '',
    content: '',
  };
  
  if (user === null) {
    errorObj.title = "Erreur - Utilisateur non authentifié";
    errorObj.content = "Vous devez vous authentifier pour accéder à ce contenu.\n " +
    "Utilisez le magic link fourni par l'administrateur du site."
  }

  const error = (user) => {
    if (user === null || user === undefined) {
      return Modal.error(errorObj);
    }
    return null
  }

  const [visibleRightDrawer, setRightDrawer] = useState(false);
  const [titleRightDrawer, setRightDrawerTitle] = useState("Test diagnostique");
  const [stepId, setStepId] = useState(null);
  const [resetParams, resetActivity] = useState(null);
  const [reference, setReference] = useState([]);


  const store = {
    user: {
      user,
      storeUser,
    },
    content: {
      content,
      setContent,
    },
    sequence: {
      sequence,
      storeSequence,
    },
    tracking: {
      answers,
      storeAnswers,
      path,
      storePath,
      activityId,
      storeActivityId,
    },
    drawer: {
      visibleRightDrawer,
      setRightDrawer,
      titleRightDrawer,
      setRightDrawerTitle,
      stepId,
      setStepId,
      reference,
      setReference
    },
    action: {
      action,
      storeAction,
      resetParams,
      resetActivity
    },
    error: {
      error,
    }
  };

  return (
    <StoreContext.Provider value={store}>
      { children }
    </StoreContext.Provider>
  );
};

export default StoreProvider;
